export default "__VITE_ASSET__d209sjIA__"